import { Link, useLocation } from 'react-router-dom';

export default function ForbiddenPage() {
  const location = useLocation();
  const requiredPermission = (location.state as { requiredPermission?: string } | null)?.requiredPermission;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-center px-4">
      <h1 className="text-2xl font-semibold">You don't have access to this page.</h1>
      <p className="text-gray-600">
        {requiredPermission
          ? <>This page requires the <code className="px-1 py-0.5 bg-gray-100 rounded text-sm">{requiredPermission}</code> permission. Ask an administrator to grant it to you.</>
          : 'If you think this is a mistake, ask an administrator to grant you the appropriate permissions.'}
      </p>
      <Link to="/" className="text-blue-600 hover:underline">Back to dashboard</Link>
    </div>
  );
}
